exports = module.exports = require("../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".toggle-container {\n  position: absolute;\n  top: 15px;\n  right: 15px;\n  z-index: 1001;\n}\n\n.toggle-container a  {\n  color: #777;\n}\n\n.toggle-container a:hover  {\n  color: #333;\n}\n", ""]);

// exports


/*** EXPORTS FROM exports-loader ***/
module.exports = module.exports.toString();


//////////////////
// WEBPACK FOOTER
// /usr/src/app/src/app/app.component.css
// module id = ../../../../../src/app/app.component.css
// module chunks = main